import { useAsync } from 'react-use';

import { errorApiRef, useApi } from '@backstage/core-plugin-api';
import { catalogApiRef } from '@backstage/plugin-catalog-react';

import { useGetUserGroups } from '../useGetUserGroups';

export const useGetKubernetesClusters = (userOwedCluster: boolean = false) => {
  const errorApi = useApi(errorApiRef);
  const catalogApi = useApi(catalogApiRef);

  const {
    value: userGroups,
    loading: userGroupsLoading,
    error: userGroupsError,
  } = useGetUserGroups();

  const {
    value: entities,
    loading,
    error,
  } = useAsync(async () => {
    const fields = [
      'metadata.title',
      'metadata.name',
      'metadata.namespace',
      'metadata.annotations',
      'kind',
      'spec.type',
      'spec.owner',
    ];

    if (userOwedCluster) {
      if (userGroupsLoading) return [];

      if (userGroupsError) {
        errorApi.post(userGroupsError);
        return [];
      }

      if (!userGroups || userGroups.length === 0) {
        return [];
      }

      const groupEntities = userGroups.map((group: string) =>
        catalogApi.getEntities({
          filter: {
            kind: 'Resource',
            'spec.type': 'kubernetes-cluster',
            'spec.owner': group,
          },
          fields,
        }),
      );

      const promises = await Promise.all(groupEntities);
      const items = promises.flatMap((result: any) => result.items);

      return items;
    }

    const { items } = await catalogApi.getEntities({
      filter: {
        kind: 'Resource',
        'spec.type': 'kubernetes-cluster',
      },
      fields,
    });
    return items;
  }, [userOwedCluster, userGroupsLoading, userGroups, userGroupsError]);

  return { value: entities, loading, error };
};
